import Select, { SelectOption } from '@amzn/meridian/select';
import React, { FC } from 'react';
import { TFunction } from '../../blocks';

interface UnitsStatusFilterProps {
    value: string[];
    onChange: (values: string[]) => void;
    t: TFunction;
}

const UnitsStatusFilter: FC<UnitsStatusFilterProps> = ({ value, onChange, t }) => (
    <Select
        value={value}
        onChange={onChange}
        label={t('unitsStatus-label')}
        placeholder={t('unitsStatus-label')}
        data-testid={'unitsStatusFilter'}
    >
        <SelectOption value={'open'} label={t('status-open')} />
        <SelectOption value={'released'} label={t('status-released')} />
        <SelectOption value={'shipped'} label={t('status-shipped')} />
        <SelectOption value={'canceled'} label={t('status-canceled')} />
    </Select>
);

export default UnitsStatusFilter;
